
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';

interface DetailedInfoStepProps {
  data: any;
  onChange: (field: string, value: any) => void;
  errors?: Record<string, string>;
}

const DetailedInfoStep = ({ data, onChange, errors }: DetailedInfoStepProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-right flex items-center gap-2">
          <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold">2</div>
          التفاصيل الكاملة
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* المساحة والغرف */}
        <div>
          <h3 className="text-lg font-semibold mb-3 text-right">المساحة والغرف</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div>
              <Label htmlFor="bedrooms">غرف النوم</Label>
              <Select value={data.bedrooms?.toString() || '1'} onValueChange={(value) => onChange('bedrooms', parseInt(value))}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {[1,2,3,4,5,6].map(num => (
                    <SelectItem key={num} value={num.toString()}>{num}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label htmlFor="bathrooms">الحمامات</Label>
              <Select value={data.bathrooms?.toString() || '1'} onValueChange={(value) => onChange('bathrooms', parseInt(value))}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {[1,2,3,4,5].map(num => (
                    <SelectItem key={num} value={num.toString()}>{num}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label htmlFor="area">المساحة (م²)</Label>
              <Input
                id="area"
                type="number"
                value={data.area || ''}
                onChange={(e) => onChange('area', parseFloat(e.target.value) || 0)}
                placeholder="120"
                className="text-right"
              />
            </div>

            <div>
              <Label htmlFor="floor_number">رقم الطابق</Label>
              <Input
                id="floor_number"
                type="number"
                value={data.floor_number || ''}
                onChange={(e) => onChange('floor_number', parseInt(e.target.value) || null)}
                placeholder="1"
                className="text-right"
              />
            </div>
          </div>
        </div>

        {/* معلومات المبنى */}
        <div>
          <h3 className="text-lg font-semibold mb-3 text-right">معلومات المبنى</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="building_age">عمر المبنى (بالسنوات)</Label>
              <Input
                id="building_age"
                type="number"
                value={data.building_age || ''}
                onChange={(e) => onChange('building_age', parseInt(e.target.value) || null)}
                placeholder="5"
                className="text-right"
              />
            </div>

            <div>
              <Label htmlFor="available_from">متاح من</Label>
              <Input
                id="available_from"
                type="date"
                value={data.available_from || new Date().toISOString().split('T')[0]}
                onChange={(e) => onChange('available_from', e.target.value)}
                className="text-right"
              />
            </div>
          </div>
        </div>

        {/* الوصف التفصيلي */}
        <div>
          <h3 className="text-lg font-semibold mb-3 text-right">الوصف التفصيلي</h3>
          <Textarea
            value={data.detailed_description || ''}
            onChange={(e) => onChange('detailed_description', e.target.value)}
            placeholder="وصف شامل ومفصل للعقار يساعد المستأجر في اتخاذ القرار"
            className="text-right"
            rows={6}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default DetailedInfoStep;
